import { useEffect, useState } from 'react';
import { publicApi, errMsg } from './fairApi';

export const useFair = (slug) => {
  const [fair, setFair] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const preview = new URLSearchParams(window.location.search).get('preview') === '1';
    const token = localStorage.getItem('token');
    const opts = preview && token ? { params: { preview: true }, headers: { Authorization: `Bearer ${token}` } } : {};
    publicApi.get(`/job-fairs/public/${slug}`, opts)
      .then((r) => { setFair(r.data); setError(''); })
      .catch((e) => setError(errMsg(e, 'Job fair not found')))
      .finally(() => setLoading(false));
  }, [slug]);

  return { fair, error, loading };
};
